import { FC, useMemo } from 'react'
import { Controller, FieldArrayPath, useFormContext } from 'react-hook-form'

import { SelectInput } from '@revolut-internal/ui-kit'

import { Security } from 'modules/security/security'
import { AlertingMetric, AlertingPolicyCreateRequest } from 'types'

type QueueHealthPolicyThresholdMetricsProps = {
  index: number
  fieldName: FieldArrayPath<AlertingPolicyCreateRequest>
  metrics?: AlertingMetric[]
}

export const QueueHealthPolicyThresholdMetrics: FC<
  QueueHealthPolicyThresholdMetricsProps
> = ({ index, fieldName, metrics }) => {
  const { control } = useFormContext()

  const isReadonly = !Security.canCreatePolicy

  const metricOptions = useMemo(
    () =>
      metrics?.map(({ id, label }) => ({
        value: id,
        key: id,
        label,
      })) ?? [],
    [metrics],
  )
  return (
    <Controller
      name={`${fieldName}.${index}.metricId`}
      control={control}
      rules={{
        required: 'Field is required',
      }}
      render={({ field, fieldState }) => (
        <SelectInput
          label="Metric"
          labelList="Metric"
          invalid={!!fieldState.error}
          errorMessage={fieldState.error?.message}
          disabled={isReadonly}
          {...field}
          searchable={false}
          options={metricOptions}
        />
      )}
    />
  )
}
